export default __webpack_public_path__ + "static/media/Parallax-HUD-Pop-Up (1 Layer).eb87bf52.jpg";